;
(function($){
    var positionTooltip = function($tooltip, $target, placement) {
        var margin = 8;
        var top = $target.position().top;
        var left = $target.position().left;
        var targetHeight = $target.outerHeight();
        var targetWidth = $target.outerWidth();
        var tooltipOuterHeight = $tooltip.outerHeight();

        var topInTheMiddleOfTarget = top + (targetHeight / 2);

        $tooltip.css({
            width: 'auto',
            top: topInTheMiddleOfTarget - (tooltipOuterHeight / 2),
            left: left + targetWidth + margin,
            display: 'block'
        });
    };

    $('[tooltip]').each(function(i, el){
        var $el = $(el);
        //style="width: auto; top: 55px; left: 878.047px; display: block;"
        var placement = $el.attr('tooltip-placement') || 'bottom';
        var content = $el.attr('tooltip');
        var tooltipHtml = '<span class="tooltip tip-' + placement + '">'
            + content       
            + '<span class="nub"></span>'
            + '</span>';
        var $tooltip = $(tooltipHtml);
        $el.on('mouseover', function(){
            $tooltip.insertAfter($el);
            positionTooltip($tooltip, $el, placement);
        });
        $el.on('mouseout', function() {
            $tooltip.remove();
        });
    });
})( jQuery );